var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block participants"},[_c('participants',{attrs:{"loading":_vm.store.isFetching.participants,"participants":_vm.store.participants,"number-of-less-participants":7}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }